import { Button } from '@blueprintjs/core';
import { useCallback } from 'react';
import { useAssignNewMLApplications } from '../../hooks/utils/useAssignNewMLApplications';

import styles from './AssignApplicationsButton.module.css';

export const AssignApplicationsButton = () => {
  const assignNewMLApplications = useAssignNewMLApplications({
    count: 1,
    shouldOpenAssignedApplications: true,
  });

  const _handleAssignClick = useCallback(() => {
    assignNewMLApplications.mutate();
  }, [assignNewMLApplications]);

  return (
    <Button
      icon="box"
      onClick={_handleAssignClick}
      className={styles.assignButton}
      text="Assign New Applications to Me"
    />
  );
};
